import ApiCalls from "../../../api";
import { store } from "../../../redux/store";

const ManageMemberUtils = {
  fetchAllMembers: async (filters = {}, paginationOptions = {}) => {
    const response = await ApiCalls.organization.private.getAllUsers(filters, paginationOptions);
    return response?.data?.data || { docs: [], totalDocs: 0, limit: 10, page: 1, totalPages: 0 };
  },
  addNewMember: async (newMember) => {
    const {userStore} = store.getState();
    const payload = {
      ...newMember,
      _organizations: [userStore.userInfo._organizations[0]],
    }
    const response = await ApiCalls.organization.private.addNewUser(payload);
    return response?.data?.data;
  },
  updateMember: async (member) => {
    const memberId = member._id;
    // delete password field if it''s exist
    if (member.password) {
      delete member.password;
    }

    const response = await ApiCalls.user.private.updateUser(memberId, member);
    return response?.data?.data;
  },
};

export default ManageMemberUtils;
